import { PDFDocument, rgb } from "pdf-lib";
import templateUrl from './template.pdf';

const val = (v) => (v == null || v === undefined ? "" : String(v));

const fill = async (pdfFormObject, highlightRect = null) => {
  // load pdf
  const existingPdfBytes = await fetch(templateUrl).then((res) => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  const pdfForm = pdfDoc.getForm();

  //Uncomment to display all pdfForm fields in console log
  // const fields = pdfForm.getFields();
  // fields.forEach((field) => {
  //   const type = field.constructor.name;
  //   const name = field.getName();
  //   console.log(`${name}`);
  // });
  // console.log(pdfFormObject);

  ////////////// FORM VARIABLES TO PDF FIELDS TRANSLATION
  var field;
  ////////// Variables on the LEFT are PDF Fields
  ////////// Variables on the RIGHT are Form Schema Variables
  field = pdfForm.getField("date");
  field.setText(val(pdfFormObject["date"]));
  field.setFontSize(8);

  field = pdfForm.getField("studentName1");
  field.setText(val(pdfFormObject["studentName"]));
  field.setFontSize(8);

  field = pdfForm.getField("oen1");
  field.setText(val(pdfFormObject["oen"]));
  field.setFontSize(8);

  field = pdfForm.getField("daysAbsent");
  field.setText(val(pdfFormObject["daysAbsent"]));
  field.setFontSize(8);

  field = pdfForm.getField("totalDaysAbsent");
  field.setText(val(pdfFormObject["totalDaysAbsent"]));
  field.setFontSize(8);

  field = pdfForm.getField("timesLate");
  field.setText(val(pdfFormObject["timesLate"]));
  field.setFontSize(8);

  field = pdfForm.getField("totalTimesLate");
  field.setText(val(pdfFormObject["totalTimesLate"]));
  field.setFontSize(8);

  field = pdfForm.getField("teacher");
  field.setText(val(pdfFormObject["teacher"]));
  field.setFontSize(8);

  field = pdfForm.getField("grade1");
  field.setText(val(pdfFormObject["grade"]));
  field.setFontSize(8);

  field = pdfForm.getField("board");
  field.setText(val(pdfFormObject["board"]));
  field.setFontSize(8);

  field = pdfForm.getField("school");
  field.setText(val(pdfFormObject["school"]));
  field.setFontSize(8);

  field = pdfForm.getField("address1");
  field.setText(val(pdfFormObject["address1"]));
  field.setFontSize(8);

  field = pdfForm.getField("address2");
  field.setText(val(pdfFormObject["address2"]));
  field.setFontSize(8);

  field = pdfForm.getField("principal");
  field.setText(val(pdfFormObject["principal"]));
  field.setFontSize(8);

  field = pdfForm.getField("telephone");
  field.setText(val(pdfFormObject["telephone"]));
  field.setFontSize(8);

  field = pdfForm.getField("gradeInSeptember");
  field.setText(val(pdfFormObject["gradeInSeptember"]));
  field.setFontSize(12);


  field = pdfForm.getField("responsibility1");
  field.setText(val(pdfFormObject["responsibility1"]));
  field.setFontSize(11);

  field = pdfForm.getField("responsibility2");
  field.setText(val(pdfFormObject["responsibility2"]));
  field.setFontSize(11);

  field = pdfForm.getField("organization1");
  field.setText(val(pdfFormObject["organization1"]));
  field.setFontSize(11);

  field = pdfForm.getField("organization2");
  field.setText(val(pdfFormObject["organization2"]));
  field.setFontSize(11);

  field = pdfForm.getField("independentWork1");
  field.setText(val(pdfFormObject["independentWork1"]));
  field.setFontSize(11);

  field = pdfForm.getField("independentWork2");
  field.setText(val(pdfFormObject["independentWork2"]));
  field.setFontSize(11);

  field = pdfForm.getField("collaboration1");
  field.setText(val(pdfFormObject["collaboration1"]));
  field.setFontSize(11);

  field = pdfForm.getField("collaboration2");
  field.setText(val(pdfFormObject["collaboration2"]));
  field.setFontSize(11);

  field = pdfForm.getField("initiative1");
  field.setText(val(pdfFormObject["initiative1"]));
  field.setFontSize(11);

  field = pdfForm.getField("initiative2");
  field.setText(val(pdfFormObject["initiative2"]));
  field.setFontSize(11);

  field = pdfForm.getField("selfRegulation1");
  field.setText(val(pdfFormObject["selfRegulation1"]));
  field.setFontSize(11);

  field = pdfForm.getField("selfRegulation2");
  field.setText(val(pdfFormObject["selfRegulation2"]));
  field.setFontSize(11);

  field = pdfForm.getField("selfRegulation1");
  field.setText(val(pdfFormObject["selfRegulation1"]));
  field.setFontSize(11);

  field = pdfForm.getField("strengthsNextStepsForImprovementLSWH");
  field.setText(val(pdfFormObject["strengthsNextStepsLSWH"]));
  field.setFontSize(8);
  field.enableMultiline();

  // SECOND PAGE
  field = pdfForm.getField("studentName2");
  field.setText(val(pdfFormObject["studentName"]));
  field.setFontSize(9);
  field = pdfForm.getField("oen2");
  field.setText(val(pdfFormObject["oen"]));
  field.setFontSize(9);
  field = pdfForm.getField("grade2");
  field.setText(val(pdfFormObject["grade"]));
  field.setFontSize(9);

  // LANGUAGE
  field = pdfForm.getField("languageESLELD");
  pdfFormObject["languagePlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("languageIEP");
  pdfFormObject["languagePlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("languageNA");
  pdfFormObject["languagePlan"] === "NA" ? field.check() : field.uncheck();
  //
  field = pdfForm.getField("languageGrade1");
  field.setText(val(pdfFormObject["languageGrade1"]));
  field.setFontSize(9);
  field = pdfForm.getField("languageGrade2");
  field.setText(val(pdfFormObject["languageGrade2"]));
  field.setFontSize(9);
  //
  field = pdfForm.getField("languageComments");
  field.setText(val(pdfFormObject["languageComments"]));
  field.setFontSize(8);
  field.enableMultiline();


  // FRENCH
  field = pdfForm.getField("frenchNA");
  pdfFormObject["frenchPlan"] === "NA" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchCore");
  pdfFormObject["frenchPlan"] === "Core" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchImmersion");
  pdfFormObject["frenchPlan"] === "Immersion" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchExtended");
  pdfFormObject["frenchPlan"] === "Extended" ? field.check() : field.uncheck();

  //
  field = pdfForm.getField("frenchListeningESLELD");
  pdfFormObject["frenchListeningPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchListeningIEP");
  pdfFormObject["frenchListeningPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchListeningGrade1");
  field.setText(val(pdfFormObject["frenchListeningGrade1"]));
  field.setFontSize(9);
  field = pdfForm.getField("frenchListeningGrade2");
  field.setText(val(pdfFormObject["frenchListeningGrade2"]));
  field.setFontSize(9);

  //
  field = pdfForm.getField("frenchSpeakingESLELD");
  pdfFormObject["frenchSpeakingPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchSpeakingIEP");
  pdfFormObject["frenchSpeakingPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchSpeakingGrade1");
  field.setText(val(pdfFormObject["frenchSpeakingGrade1"]));
  field.setFontSize(9);
  field = pdfForm.getField("frenchSpeakingGrade2");
  field.setText(val(pdfFormObject["frenchSpeakingGrade2"]));
  field.setFontSize(9);

  //
  field = pdfForm.getField("frenchReadingESLELD");
  pdfFormObject["frenchReadingPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchReadingIEP");
  pdfFormObject["frenchReadingPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchReadingGrade1");
  field.setText(val(pdfFormObject["frenchReadingGrade1"]));
  field.setFontSize(9);
  field = pdfForm.getField("frenchReadingGrade2");
  field.setText(val(pdfFormObject["frenchReadingGrade2"]));
  field.setFontSize(9);

  //
  field = pdfForm.getField("frenchWritingESLELD");
  pdfFormObject["frenchWritingPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchWritingIEP");
  pdfFormObject["frenchWritingPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("frenchWritingGrade1");
  field.setText(val(pdfFormObject["frenchWritingGrade1"]));
  field.setFontSize(9);
  field = pdfForm.getField("frenchWritingGrade2");
  field.setText(val(pdfFormObject["frenchWritingGrade2"]));
  field.setFontSize(9);

  //
  field = pdfForm.getField("frenchComments");
  field.setText(val(pdfFormObject["frenchComments"]));
  field.setFontSize(8);
  field.enableMultiline();

  // NATIVE LANGUAGE
field = pdfForm.getField("nativeLanguage");
field.setText(val(pdfFormObject["nativeLanguage"]));
field.setFontSize(9);
field = pdfForm.getField("nativeLanguageESLELD");
pdfFormObject["nativeLanguagePlan"] === "ESLELD" ? field.check() : field.uncheck();
field = pdfForm.getField("nativeLanguageIEP");
pdfFormObject["nativeLanguagePlan"] === "IEP" ? field.check() : field.uncheck();
field = pdfForm.getField("nativeLanguageNA");
pdfFormObject["nativeLanguagePlan"] === "NA" ? field.check() : field.uncheck();

field = pdfForm.getField("nativeLanguageGrade1");
field.setText(val(pdfFormObject["nativeLanguageGrade1"]));
field.setFontSize(9);
field = pdfForm.getField("nativeLanguageGrade2");
field.setText(val(pdfFormObject["nativeLanguageGrade2"]));
field.setFontSize(9);

field = pdfForm.getField("nativeLanguageComments");
field.setText(val(pdfFormObject["nativeLanguageComments"]));
field.setFontSize(8);
field.enableMultiline();

// MATHEMATICS
field = pdfForm.getField("mathematicsESLELD");
pdfFormObject["mathematicsPlan"] === "ESLELD" ? field.check() : field.uncheck();
field = pdfForm.getField("mathematicsIEP");
pdfFormObject["mathematicsPlan"] === "IEP" ? field.check() : field.uncheck();
field = pdfForm.getField("mathematicsFrench");
pdfFormObject["mathematicsPlan"] === "French" ? field.check() : field.uncheck();

field = pdfForm.getField("mathematicsGrade1");
field.setText(val(pdfFormObject["mathematicsGrade1"]));
field.setFontSize(9);
field = pdfForm.getField("mathematicsGrade2");
field.setText(val(pdfFormObject["mathematicsGrade2"]));
field.setFontSize(9);

field = pdfForm.getField("mathematicsComments");
field.setText(val(pdfFormObject["mathematicsComments"]));
field.setFontSize(8);
field.enableMultiline();


// SCIENCE AND TECHNOLOGY
field = pdfForm.getField("scienceAndTechnologyESLELD");
pdfFormObject["scienceAndTechnologyPlan"] === "ESLELD" ? field.check() : field.uncheck();
field = pdfForm.getField("scienceAndTechnologyIEP");
pdfFormObject["scienceAndTechnologyPlan"] === "IEP" ? field.check() : field.uncheck();
field = pdfForm.getField("scienceAndTechnologyFrench");
pdfFormObject["scienceAndTechnologyPlan"] === "French" ? field.check() : field.uncheck();

field = pdfForm.getField("scienceAndTechnologyGrade1");
field.setText(val(pdfFormObject["scienceAndTechnologyGrade1"]));
field.setFontSize(9);
field = pdfForm.getField("scienceAndTechnologyGrade2");
field.setText(val(pdfFormObject["scienceAndTechnologyGrade2"]));
field.setFontSize(9);

field = pdfForm.getField("scienceAndTechnologyComments");
field.setText(val(pdfFormObject["scienceAndTechnologyComments"]));
field.setFontSize(8);
field.enableMultiline();





  // THIRD PAGE
  field = pdfForm.getField("studentName3");
  field.setText(val(pdfFormObject["studentName"]));
  field.setFontSize(9);
  field = pdfForm.getField("oen3");
  field.setText(val(pdfFormObject["oen"]));
  field.setFontSize(9);
  field = pdfForm.getField("grade3");
  field.setText(val(pdfFormObject["grade"]));
  field.setFontSize(9);


// SOCIAL STUDIES
field = pdfForm.getField("socialStudiesESLELD");
pdfFormObject["socialStudiesPlan"] === "ESLELD" ? field.check() : field.uncheck();
field = pdfForm.getField("socialStudiesIEP");
pdfFormObject["socialStudiesPlan"] === "IEP" ? field.check() : field.uncheck();
field = pdfForm.getField("socialStudiesFrench");
pdfFormObject["socialStudiesPlan"] === "French" ? field.check() : field.uncheck();

field = pdfForm.getField("socialStudiesGrade1");
field.setText(val(pdfFormObject["socialStudiesGrade1"]));
field.setFontSize(9);
field = pdfForm.getField("socialStudiesGrade2");
field.setText(val(pdfFormObject["socialStudiesGrade2"]));
field.setFontSize(9);

field = pdfForm.getField("socialStudiesComments");
field.setText(val(pdfFormObject["socialStudiesComments"]));
field.setFontSize(8);
field.enableMultiline();


// HEALTH EDUCATION
field = pdfForm.getField("healthEducationESLELD");
pdfFormObject["healthEducationPlan"] === "ESLELD" ? field.check() : field.uncheck();
field = pdfForm.getField("healthEducationIEP");
pdfFormObject["healthEducationPlan"] === "IEP" ? field.check() : field.uncheck();
field = pdfForm.getField("healthEducationFrench");
pdfFormObject["healthEducationPlan"] === "French" ? field.check() : field.uncheck();



field = pdfForm.getField("healthEducationGrade1");
field.setText(val(pdfFormObject["healthEducationGrade1"]));
field.setFontSize(9);


field = pdfForm.getField("healthEducationGrade2");
field.setText(val(pdfFormObject["healthEducationGrade2"]));
field.setFontSize(9);



// PHYSICAL EDUCATION
field = pdfForm.getField("physicalEducationESLELD");
pdfFormObject["physicalEducationPlan"] === "ESLELD" ? field.check() : field.uncheck();
field = pdfForm.getField("physicalEducationIEP");
pdfFormObject["physicalEducationPlan"] === "IEP" ? field.check() : field.uncheck();
field = pdfForm.getField("physicalEducationFrench");
pdfFormObject["physicalEducationPlan"] === "French" ? field.check() : field.uncheck();

field = pdfForm.getField("physicalEducationGrade1");
field.setText(val(pdfFormObject["physicalEducationGrade1"]));
field.setFontSize(9);
field = pdfForm.getField("physicalEducationGrade2");
field.setText(val(pdfFormObject["physicalEducationGrade2"]));
field.setFontSize(9);

field = pdfForm.getField("healthAndPhysicalEducationComments");
field.setText(val(pdfFormObject["healthAndPhysicalEducationComments"]));
field.setFontSize(8);
field.enableMultiline();

// ARTS

  field = pdfForm.getField("artsHeader");
  field.setText(val(pdfFormObject["artsHeader"]));
  field.setFontSize(9);


  // ARTS 1
  field = pdfForm.getField("arts1");
  field.setText(val(pdfFormObject["arts1"]));
  field.setFontSize(8);

  field = pdfForm.getField("arts1French");
  pdfFormObject["arts1Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1ESLELD");
  pdfFormObject["arts1Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1IEP");
  pdfFormObject["arts1Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1NA");
  pdfFormObject["arts1Plan"] === "NA" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts1Grade1");
    field.setText(val(pdfFormObject["arts1Grade1"]));
    field.setFontSize(9);
    field = pdfForm.getField("arts1Grade2");
    field.setText(val(pdfFormObject["arts1Grade2"]));
    field.setFontSize(9);

  field = pdfForm.getField("arts2");
  field.setText(val(pdfFormObject["arts2"]));
  field.setFontSize(8);

  field = pdfForm.getField("arts2French");
  pdfFormObject["arts2Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2ESLELD");
  pdfFormObject["arts2Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2IEP");
  pdfFormObject["arts2Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2NA");
  pdfFormObject["arts2Plan"] === "NA" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts2Grade1");
    field.setText(val(pdfFormObject["arts2Grade1"]));
    field.setFontSize(9);
    field = pdfForm.getField("arts2Grade2");
    field.setText(val(pdfFormObject["arts2Grade2"]));
    field.setFontSize(9);

  field = pdfForm.getField("arts3");
  field.setText(val(pdfFormObject["arts3"]));
  field.setFontSize(8);
  field = pdfForm.getField("arts3French");
  pdfFormObject["arts3Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3ESLELD");
  pdfFormObject["arts3Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3IEP");
  pdfFormObject["arts3Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3NA");
  pdfFormObject["arts3Plan"] === "NA" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts3Grade1");
    field.setText(val(pdfFormObject["arts3Grade1"]));
    field.setFontSize(9);
    field = pdfForm.getField("arts3Grade2");
    field.setText(val(pdfFormObject["arts3Grade2"]));
    field.setFontSize(9);

  field = pdfForm.getField("arts4");
  field.setText(val(pdfFormObject["arts4"]));
  field.setFontSize(8);
  field = pdfForm.getField("arts4French");
  pdfFormObject["arts4Plan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4ESLELD");
  pdfFormObject["arts4Plan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4IEP");
  pdfFormObject["arts4Plan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4NA");
  pdfFormObject["arts4Plan"] === "NA" ? field.check() : field.uncheck();
  field = pdfForm.getField("arts4Grade1");
    field.setText(val(pdfFormObject["arts4Grade1"]));
    field.setFontSize(9);
    field = pdfForm.getField("arts4Grade2");
    field.setText(val(pdfFormObject["arts4Grade2"]));
    field.setFontSize(9);



  field = pdfForm.getField("artsComments");
  field.setText(val(pdfFormObject["artsComments"]));
  field.setFontSize(8);
  field.enableMultiline();

  field = pdfForm.getField("optionalStudies");
  field.setText(val(pdfFormObject["optionalStudies"]));
  field.setFontSize(9);
  field = pdfForm.getField("optionalStudiesFrench");
  pdfFormObject["optionalStudiesPlan"] === "French" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesESLELD");
  pdfFormObject["optionalStudiesPlan"] === "ESLELD" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesIEP");
  pdfFormObject["optionalStudiesPlan"] === "IEP" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesNA");
  pdfFormObject["optionalStudiesPlan"] === "NA" ? field.check() : field.uncheck();
  field = pdfForm.getField("optionalStudiesGrade1");
    field.setText(val(pdfFormObject["optionalStudiesGrade1"]));
    field.setFontSize(9);
    field = pdfForm.getField("optionalStudiesGrade2");
    field.setText(val(pdfFormObject["optionalStudiesGrade2"]));
    field.setFontSize(9);
    field = pdfForm.getField("optionalStudiesComments");
    field.setText(val(pdfFormObject["optionalStudiesComments"]));
    field.setFontSize(8);
    field.enableMultiline();

  // ERS Section
  field = pdfForm.getField("ersCompletedYes");
  pdfFormObject["ersCompleted"] === "Yes" ? field.check() : field.uncheck();
  field = pdfForm.getField("ersCompletedNo");
  pdfFormObject["ersCompleted"] === "No" ? field.check() : field.uncheck();
  field = pdfForm.getField("ersCompletedNA");
  pdfFormObject["ersCompleted"] === "NA" ? field.check() : field.uncheck();

  field = pdfForm.getField("ersDateYear");
  field.setText(val(pdfFormObject["ersDateYear"]));
  field = pdfForm.getField("ersDateMonth");
  field.setText(val(pdfFormObject["ersDateMonth"]));
  field = pdfForm.getField("ersDateDay");
  field.setText(val(pdfFormObject["ersDateDay"]));

  field = pdfForm.getField("ersBenchmarkYes");
  pdfFormObject["ersBenchmark"] === "Yes" ? field.check() : field.uncheck();
  field = pdfForm.getField("ersBenchmarkNo");
  pdfFormObject["ersBenchmark"] === "No" ? field.check() : field.uncheck();

  // FOURTH  PAGE
  field = pdfForm.getField("studentName4");
  field.setText(val(pdfFormObject["studentName"]));
  field.setFontSize(9);
  field = pdfForm.getField("oen4");
  field.setText(val(pdfFormObject["oen"]));
  field.setFontSize(9);
  field = pdfForm.getField("grade4");
  field.setText(val(pdfFormObject["grade"]));
  field.setFontSize(9);


  // TODO (unsupported ) field = pdfForm.getField( teacherSignature
  // TODO (unsupported ) field = pdfForm.getField( principalSignature


  // TOD0: add strengths and next steps field for subject improvment field
  pdfForm.flatten();

  if (highlightRect) {
    const { pageIndex, x, y, width, height } = highlightRect;
    const pages = pdfDoc.getPages();
    if (pages[pageIndex]) {
      pages[pageIndex].drawRectangle({
        x: x - 2,
        y: y - 2,
        width: width + 4,
        height: height + 4,
        color: rgb(0, 0.55, 0),
        opacity: 0.25,
        borderColor: rgb(0.9, 0.7, 0),
        borderWidth: 0,
        borderOpacity: 0.9,
      });
    }
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const filledPDFUrl = URL.createObjectURL(blob);
  console.log(filledPDFUrl);
  return filledPDFUrl;
};

export { fill };
